/**
 * Adds "18+" marker to adult tags
 */
export const addAdultMarkerToTags = <
  T extends { title?: string; isAdult?: boolean; is_adult?: boolean },
>(
  tags?: T[],
): T[] => {
  if (!tags) return [];

  return tags.map((tag) =>
    Object.assign(tag, {
      title: `${tag.title}${tag.isAdult || tag.is_adult ? ' 18+' : ''}`.trim(),
    }),
  );
};
